/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Social_Export_PublishingInputs */

const cs_social_export_publishing = /** @type {(inputs: Social_Export_PublishingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publikuji…`)
};

const en_social_export_publishing = /** @type {(inputs: Social_Export_PublishingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publishing…`)
};

/**
* | output |
* | --- |
* | "Publishing…" |
*
* @param {Social_Export_PublishingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const social_export_publishing = /** @type {((inputs?: Social_Export_PublishingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Social_Export_PublishingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_social_export_publishing(inputs)
	return cs_social_export_publishing(inputs)
});